import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

export type CardProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  displayAsClickable?: boolean;
  as?: 'article' | 'section' | 'div';
};

export const Card = (props: CardProps) => {
  const Element = props.as ?? 'article';
  return (
    <Element className={classNames(
      props.className,
      'tds-card p-200 md:p-300',
      { 'tds-card-clickable': props.displayAsClickable },
    )} {...omit(props, 'className', 'displayAsClickable')} />
  );
};
